import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { TrashSystemsColumnKeys } from './trash-systems.enum';
import { TrashSystem } from 'src/app/api/models/systems/systems.interface';
import { ProfileQuery } from 'src/app/profile/state/profile.query';
import { CustomFieldsV2Service } from 'src/app/company-settings/custom-fields-v2/custom-fields-v2.service';
import { PredefinedFieldNameEnum } from 'src/app/api/models/company-settings/custom-field-v2.enum';

@Injectable()
export class TrashSystemsTableCsvHelper {
    reasons: { id: string; name: string }[];

    constructor(
        private datePipe: DatePipe,
        private profileQuery: ProfileQuery,
        private customFieldsV2Service: CustomFieldsV2Service,
    ) { }

    getValueByKey(system: TrashSystem, key: TrashSystemsColumnKeys): string {
      this.reasons = (this.customFieldsV2Service.getField(PredefinedFieldNameEnum.DecommissionJustification)?.options ?? [])
        .map(o => ({ id: o.id, name: o.text }));

      const values: Record<TrashSystemsColumnKeys, string> = {
        name: system.name ?? '-',
        removalReason: this.getReason(system.removalReason),
        updatedBy: this.getUpdatedBy(system),
        lastUpdate: system.removeDate ? this.datePipe.transform(system.removeDate, 'MMM dd, yyyy') : '-',
      };
      return values[key];
    }

    getUpdatedBy(system: TrashSystem): string {
        if (system.removedBy) {
            return this.profileQuery.getAgentById(system.removedBy)?.name ?? '-';
        }
        return '-';
    }

    getReason(customValueId: string): string {
      return this.reasons.find(({ id }) => id === customValueId)?.name ?? '-';
    }
}
